/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FiltroCreateDTO
 */
export interface FiltroCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof FiltroCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof FiltroCreateDTO
     */
    espressione?: string;
}

/**
 * Check if a given object implements the FiltroCreateDTO interface.
 */
export function instanceOfFiltroCreateDTO(value: object): value is FiltroCreateDTO {
    return true;
}

export function FiltroCreateDTOFromJSON(json: any): FiltroCreateDTO {
    return FiltroCreateDTOFromJSONTyped(json, false);
}

export function FiltroCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiltroCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'espressione': json['espressione'] == null ? undefined : json['espressione'],
    };
}

export function FiltroCreateDTOToJSON(value?: FiltroCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'espressione': value['espressione'],
    };
}

